// extracted by mini-css-extract-plugin
export default {"root":"AULV4EBm","block":"swplW1dc"};